export default "__VITE_ASSET__aRzXF_R6__"